<template>
  <div class="about">
    <div class="row align-items-center">
      <div class="col-lg-10">
        <h1 class="mb-3">Немного обо мне</h1>
        <p class="about__text mb-5">
          Меня зовут Александр, я&nbsp;frontend разработчик. <br />
          В данный момент работаю в Mail.ru над проектами почта и облако. Опыт в разработке более 4 лет. <br />
          Также немного увлекаюсь backend разработкой на Nest.js + Postgres. <br />
          Если у вас есть интересный проект, буду рад сотрудничеству.
        </p>

        <h1 class="mb-3">Технологии, которые я использую</h1>
        <SkillItem
          v-for="(skill, i) in skills"
          :key="i"
          :percent="skill.percent"
          :title="skill.title"
          :timeout="skill.timeout"
          :theme="skill.theme"
          :transition="skill.transition"
        />
        <div class="mb-5"></div>

        <h1 class="mb-3">Связь со мной</h1>
        <Social />
      </div>
    </div>
  </div>
</template>

<script>
import Social from '@/components/Social';
import SkillItem from '@/components/SkillItem';

export default {
  name: 'About',
  data: () => ({
    skills: [
      {
        title: 'HTML',
        timeout: 0,
        theme: 'orange'
      },
      {
        title: 'CSS',
        timeout: 25,
        theme: 'blue'
      },
      {
        title: 'JavaScript',
        timeout: 50,
        theme: 'yellow'
      },
      {
        title: 'TypeScript',
        timeout: 50,
        theme: 'sky-blue'
      },
      {
        title: 'React.js',
        timeout: 100,
        theme: 'turquoise'
      },
      {
        title: 'Vue.js',
        timeout: 150,
        theme: 'green'
      },
      {
        title: 'Nest.js',
        timeout: 200,
        theme: 'red'
      },
      {
        title: 'PostgreSQL',
        timeout: 250,
        theme: 'dark-blue'
      }
    ]
  }),
  components: {
    Social,
    SkillItem
  }
};
</script>

<style lang="scss" scoped>
.about {
  &__text {
    font-size: 18px;
  }
}
</style>
